<template>
  <div
    v-if="bussola && thumbnail"
    :class="{
      'col-12 md:col-4 sm:col-6': !sidebar,
    }"
  >
    <div class="pb-0 flex flex-wrap card-sidebar">
      <h2 class="title w-full pb-2">"A Bússola"</h2>
      <div class="w-full flex card-content">
        <a v-if="bussola.id" href="#" @click="openInNewTab">
          <img
            :src="thumbnail"
            class="pr-5 pb-0"
            style="height: 200px; display: block"
          />
        </a>
        <div class="flex flex-column justify-content-between w-full">
          <div>
            <div class="">{{ $t("edition_number") }}{{ number }}</div>
            <div class="mt-2 mb-2 desc text-700">
              {{ description }}
            </div>
          </div>
          <div
            class="
              see_more
              cursor-pointer
              py-1
              px-4
              text-xs
              ml-auto
              text-center
            "
            @click="openInNewTab"
          >
            {{ $t("see_more") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  props: {
    bussola: { type: Object, default: null },
    sidebar: { type: Boolean, default: false },
  },
  setup(props) {
    const thumbnail = ref("");
    const description = ref("");
    const fetchThumbnail = async () => {
      if (props.bussola && props.bussola.featured_media) {
        try {
          const response = await fetch(
            `https://abussola.b-emigrante.com/wp-json/wp/v2/media/${props.bussola.featured_media}`
          );
          const media = await response.json();
          thumbnail.value = media.source_url;
        } catch (error) {
          console.error("Erro ao buscar thumbnail:", error);
        }
      }
    };

    onMounted(async () => {
      await fetchThumbnail();

      if (props.bussola.descricao) {
        description.value = props.bussola.descricao;
      }
    });

    return { thumbnail, description };
  },
  computed: {
    number() {
      if (this.bussola && this.bussola.title && this.bussola.title.rendered) {
        const numberMatch = this.bussola.title.rendered.match(/(\d+)/);
        return numberMatch ? numberMatch[1] : null;
      }
      return null;
    },
    publishDate() {
      if (this.bussola && this.bussola.title && this.bussola.title.rendered) {
        const dateMatch = this.bussola.title.rendered.match(/(\w+ \d+)$/);
        return dateMatch ? dateMatch[1] : null;
      }
      return null;
    },
  },
  methods: {
    openInNewTab() {
      window.open(this.bussola.link, "_blank");
    },
  },
};
</script>
